import React from "react";
import styles from "./target-audience-mobile.module.scss";
import { useTranslation } from "react-i18next";
import autoIcon from "@/assets/auto.svg";
import cartIcon from "@/assets/cart.svg";
import boxesIcon from "@/assets/boxes.svg";
import shippingIcon from "@/assets/shipping.svg";

import cubeIcon from "@/assets/cube.svg";
import keyIcon from "@/assets/key.svg";
import basketIcon from "@/assets/basket.svg";
import warehouseIcon from "@/assets/warehouse.svg";
import sheetIcon from "@/assets/sheet.svg";
import carIcon from "@/assets/minicar.svg";
import { Icon } from "@/elements-react/fix-icon";

export const TargetAudienceMobile: React.FC = () => {
    const { t } = useTranslation();

    const audiences = [
        {
            icons: [cubeIcon, keyIcon],
            title: "Garages & service stations",
            description: "Fast access to stock, alternatives and repeat orders"
        },
        {
            icons: [basketIcon],
            title: "Auto parts retailers",
            description: "Full control over baskets, pricing and deliveries"
        },
        {
            icons: [warehouseIcon],
            title: "Distributors & wholesalers",
            description: "Scalable ordering and availability management"
        },
        {
            icons: [sheetIcon, carIcon],
            title: "Dealers & fleet operators",
            description: "Reliable supply with full order history"
        }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>
                {t("Designed for automotive professionals")}
            </h2>
            <p className={styles.subtitle}>
                {t("Built for daily ordering and operational work")}
            </p>

            <div className={styles.grid}>
                {audiences.map((item, index) => (
                    <div key={index} className={styles.card}>
                        <div className={styles.cardIcons}>
                            {item.icons.map((icon, iconIndex) => (
                                <Icon key={iconIndex} src={icon} className={styles.cardIcon} />
                            ))}
                        </div>
                        <div className={styles.cardTitle}>{t(item.title)}</div>
                        <div className={styles.cardDescription}>{t(item.description)}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};
